import React from "react";

import "./ArrowLine.scss";

export const ArrowLine = () => (
    <div className="arrow-line" />
);
